import React, { useState,useEffect } from "react";
import Header from '../layout/header';
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import axios from 'axios'

const ReferralsOptions = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [roleId, setRoleId] = useState('')
    const [isPm,setIsPm]=useState('');
    const [hasBaTeam,setHasBaTeam]=useState(null);
    useEffect(async() => {
        let isPm = await localStorage.getItem('is_pm')
        const userProfileData = await localStorage.getItem('user_profile');
        let userProfile;

        try {
            userProfile = userProfileData ? JSON.parse(userProfileData) : null;
        } catch (error) {
            console.error('Failed to parse user profile:', error);
            userProfile = null;
        }

        if (userProfile && Array.isArray(userProfile.teams)) {
            const hasTeam = userProfile.teams.some(team => (team.team_id == 4 && team.department_id == 3));
            setHasBaTeam(hasTeam);
        } else {
            setHasBaTeam(false);
        }

        setIsPm(isPm)
    }, [])

    useEffect(() => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
    }, [])
    return (
        <>
          <Loader isLoading={isLoading} />
          <div id="wrapper">
            <DashboardMenu />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <Header title={'Referrals'} />
                <div className="container-fluid common-bg">
                    <div className="container-fluid bootstrap snippets bg-white">
                        <div className="row">
                            <div className="col-md-12 d-flex flex-column mt-20px">
                                <h1 className="h3 mb-4 text-black-100">Referrals</h1>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <a href="/new-referral" style={{ textDecoration: 'none' }}>
                                            <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Drop a new Referral</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/referrals-status" style={{ textDecoration: 'none' }}>
                                            <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Status of My Referrals</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    {(isPm === 'true') && (
                                        <>
                                            <div className="col-md-3 mb-3">
                                                <a href="/referrals-pending" style={{ textDecoration: 'none' }}>
                                                    <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                        <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                            <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Referrals Pending for action</h5>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <a href="/referrals-received" style={{ textDecoration: 'none' }}>
                                                    <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                        <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                            <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Referrals Received to My Department</h5>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <a href="/referrals-given" style={{ textDecoration: 'none' }}>
                                                    <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                        <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                            <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Referrals Given by My Department</h5>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </>
                                    )}
                                    {(isPm === 'false') && (
                                        <div className="col-md-3 mb-3">
                                            <a href="/referrals-assigned" style={{ textDecoration: 'none' }}>
                                                <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                    <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                        <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Referrals Assigned to me</h5>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )}
                                    {
                                        (hasBaTeam) && (
                                        <div className="col-md-3 mb-3">
                                            <a href="/referrals-sites-calling" style={{ textDecoration: 'none' }}>
                                                <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                    <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                        <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Sites for Calling</h5>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
};

export default ReferralsOptions;